package core.exception

@OptIn(ExperimentalJsExport::class)
@JsExport
class CannotReadFileException : Throwable()
